/**
 * @generated SignedSource<<6a61d0144da2ed4264463ab90b0e15e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksIsShowTypeformArticle$data = {
  readonly entityUuid: string;
  readonly " $fragmentType": "hooksIsShowTypeformArticle";
};
export type hooksIsShowTypeformArticle$key = {
  readonly " $data"?: hooksIsShowTypeformArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksIsShowTypeformArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksIsShowTypeformArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityUuid",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "0fac412324a96fc21ff799f8a8c44e97";

export default node;
